
  <h1
  style="
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
      Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-weight: 500;
    color: #105481;
    margin-bottom: 0.5rem;
    font-size: 2.5rem;
    font-weight: 500;
    line-height: 1.2;
  "
>
 {{particularRow.key.infRef.infRefName}}
</h1>
<mat-tab-group
color="primary"
mat-align-tabs="center"
(selectedTabChange)="onTabChange($event)"
class="tabs"

>
<mat-tab label="Detaljer" class="tabs" style="height: 100%">
 <app-edit-route-form #routeform (submitClickedEvent)="editSubmit()" (cancelClickEvent)="cancelClick()" [particularRow]="particularRow" (cancelEvent)="cancel()" ></app-edit-route-form>
</mat-tab>

<mat-tab label="Ændringslog">
  <app-route-history  [history]="history" (cancelEvent)="cancelClick()"></app-route-history>
</mat-tab>
</mat-tab-group>
